<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="selectGoods">选择商品</button>
            </div>
        </div>
        <div class="right">
            <span class="ml10" v-if="goodsRecvReturnItemList != null && goodsRecvReturnItemList.length > 0">已选择{{ optionFlag == 'return' ? '退' : '换' }}货商品数({{goodsRecvReturnItemList.length}})</span>
            <!--<span v-if="returnQuantity != null">需退货商品数({{returnQuantity}})</span>-->
            <!--<span v-if="exchgQuantity != null">需换货商品数({{exchgQuantity}})</span>-->
        </div>
        <el-table ref="multipleTable" :data="goodsRecvReturnItemList" border tooltip-effect="dark" style="width: 100%">
            <el-table-column align="left" prop="title" label="商品名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="tmpNo" label="系统编号" width="240" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="vendorUkno" label="商品标识码" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="quantity" label="数量" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="theUnit" label="单位" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="batchNo" label="批次号" width="140" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" width="80" label="操作" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { showGoodsRecvVoucherItemListForSelectDialog } from '../order/dialog'

    import goodsDelivApi from '../../api/goodsDeliv'

    export default {
        name: 'swb-goods-recv-return-item-list',
        desc: '退换货商品明细',
        props: {
            recvVoucherId: {
                type: Number,
                default: null
            },
            recvVoucherItemId: {
                type: Number,
                default: null
            },
            returnQuantity: {
                type: Number,
                default: null
            },
            exchgQuantity: {
                type: Number,
                default: null
            },
            goodsRecvReturnItems: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            optionFlag: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //
                goodsRecvReturnItemList: [],
                selectItems: []
            }
        },
        created: function () {
            if(this.goodsRecvReturnItems.length > 0) {
                this.goodsRecvReturnItemList = Utils.merge([], this.goodsRecvReturnItems);
            }
        },
        methods: {
            // 选择具体的退换货商品
            selectGoods: function () {
                let self = this;
                let ioFlag = 1;
                let assetTypes = [];
                let assetType = getEnumInfoWith('assetType', 'name', 'CommonDevc').value;
                assetTypes.push(assetType);
                showGoodsRecvVoucherItemListForSelectDialog(self.recvVoucherId, self.recvVoucherItemId, ioFlag, null, self.selectItems, "returnExchg", assetTypes, function (returnGoods) {
                    returnGoods = returnGoods || [];
                    self.selectItems = Utils.merge([], returnGoods);
                    //
                    let itemList = [];
                    for(let i = 0; i < returnGoods.length; i++) {
                        let recvItem = returnGoods[i];
                        // 退货明细项
                        let item = {
                            id: recvItem.devcItemId,
                            deriveId: recvItem.voucherId,
                            deriveItemId: recvItem.id,
                            assetType: recvItem.assetType,
                            tmpNo: recvItem.tmpNo,
                            vendorUkno: recvItem.vendorUkno,
                            model: recvItem.model,
                            fixedSpec: recvItem.fixedSpec,
                            warehouseId: recvItem.warehouseId,
                            warehouseName: recvItem.warehouseName,
                            title: recvItem.title,
                            catId: recvItem.catId,
                            catName: recvItem.catName,
                            brandId: recvItem.brandId,
                            brandName: recvItem.brandName,
                            quantity: 1,
                            theUnit: recvItem.unit,
                            batchNo: recvItem.batchNo
                        };

                        itemList.push(item);
                    }
                    //
                    self.goodsRecvReturnItemList = Utils.merge([], itemList);
                });
            },
            // 移除商品
            removeGoods: function (index) {
                let goodsRecvReturnItemList = this.goodsRecvReturnItemList || [];
                let deviceXId = null;
                for(let i = 0; i < goodsRecvReturnItemList.length; i++) {
                    if(i == index) {
                        let goodsRecvReturnItem = goodsRecvReturnItemList[i];
                        deviceXId = goodsRecvReturnItem.deviceXId;
                        goodsRecvReturnItemList.splice(i, 1);
                        break;
                    }
                }
                this.goodsRecvReturnItemList = Utils.merge([], goodsRecvReturnItemList);
                //
                if(!Utils.isNoB(deviceXId)) {
                    let selectItems = this.selectItems || [];
                    for(let i = 0; i < selectItems.length; i++) {
                        let selectItem = selectItems[i];
                        if(!Utils.isNoB(selectItem.deviceXId) && deviceXId == selectItem.deviceXId) {
                            selectItems.splice(i, 1);
                            break;
                        }
                    }
                    this.selectItems = Utils.merge([], selectItems);
                }
            },

            getDlgResult: function () {
                let result = {};
                //
                let goodsRecvReturnItemList = this.goodsRecvReturnItemList || [];
                if(goodsRecvReturnItemList.length > 0) {
                    //
                    result.type = 'info';
                    result.data = goodsRecvReturnItemList;
                } else {
                    result.type = 'warn';
                    result.message = "请选择需要退换货的具体商品！";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsRecvReturnItemList.vue